module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.personale), function(persona) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(persona.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(persona.numberOfMales))])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Stillingstype")]), _vm._v(" "), _c('th', [_vm._v("Alder")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6963107e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/ResumePersonaleSkema.vue
// module id = 1696
// module chunks = 1